module.exports = __webpack_public_path__ + "img/shop.4f71da69.svg";